<template>
    <div class="bg-red home">
        <div class="home-wrapper container">
            <div class="adorn-wrapper">
                <div class="adorn-1">
                    <img src="@/assets/common_ic_03.png" alt="" class="icon">
                </div>
                <div class="adorn-2">
                    <img src="@/assets/common_ic_02.png" alt="" class="icon">
                </div>
                <div class="adorn-3">
                    <img src="@/assets/common_ic_04.png" alt="" class="icon">
                </div>
                <div class="adorn-4">
                    <img src="@/assets/common_ic_02.png" alt="" class="icon">
                </div>
                <div class="adorn-5">
                    <img src="@/assets/common_ic_01.png" alt="" class="icon">
                </div>
                <div class="adorn-6">
                    <img src="@/assets/common_ic_05.png" alt="" class="icon">
                </div>
                <div class="adorn-7">
                    <img src="@/assets/common_ic_02.png" alt="" class="icon">
                </div>
            </div>
            <div class="left">
                <h2 class="title">
                    <!--開運笑起來-->
                </h2>
                <p class="subtitle">
                    <!--2020這樣笑 招福最有效-->
                </p>
                <div class="info mb-hide block">
                    <img src="@/assets/home_qrcode.png" class="qrcode" alt="">
                    <p class="text">
                        立即掃描QRcode<br>
                        檢測運勢再抽好禮
                    </p>
                </div>
            </div>
            <div class="right">
                <img src="@/assets/home_main_image_pc.png" class="image"
                v-if="isPc">
                <img src="@/assets/home_main_image.png" class="image" v-else>
                <div class="toothpastes">
                    <div class="right-toothpaste"></div>
                    <div class="left-toothpaste"></div>
                </div>
                <div class="pc-hide block btn-wrapper">
                    <button type="button"
                    class="btn btn-circle btn-yellow btn-right"
                    @click="goPage('Activity'); gaEvent('test_btn', 'start_test');">
                    立即研究
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import mixinMethod from '@/js/mixin/mixinMethod';

export default {
    name: 'Home',
    computed: {
        isPc() {
            return window.innerWidth > 768;
        },
    },
    mixins: [mixinMethod],
};

</script>
